import dayjs from "dayjs";
import { ReactNode } from "react";
import { dateFormat } from "../../constants/constants";
import { formatDate } from "../../lib/time";
import { EType, JType } from "../../pages/admin/JobPost/JobPost";
import { jobGenderList } from "../../pages/admin/JobPost/ManageJob";
import { JobPostDetail } from "../../types";

type Props = {
  data?: JobPostDetail;
};

export default function JobDetailsView({ data }: Props) {
  const isShowCompany =
    data?.createdByMember?.business?.name ||
    data?.company_no_of_employees ||
    data?.company_website;

  return (
    <div>
      {!!data?.no_of_vacancies && (
        <JobItem title="Vacancy">{data?.no_of_vacancies}</JobItem>
      )}
      {!!data?.job_context && (
        <JobItem title="Job Context">
          <p dangerouslySetInnerHTML={{ __html: data?.job_context }} />
        </JobItem>
      )}
      {!!data?.job_description && (
        <JobItem title="Job Description">
          <p
            dangerouslySetInnerHTML={{ __html: data?.job_description || "" }}
          />
        </JobItem>
      )}
      {!!data?.experience_requirements && (
        <JobItem title="Experience Requirements">
          <p
            dangerouslySetInnerHTML={{
              __html: data?.experience_requirements || "",
            }}
          />
        </JobItem>
      )}
      <JobItem title="Employment Type">
        {data?.employment_status ? EType[data?.employment_status] : ""}
      </JobItem>
      {!!data?.experience_requirements && (
        <JobItem title="Educational Requirements">
          <p
            dangerouslySetInnerHTML={{
              __html: data?.educational_requirements || "",
            }}
          />
        </JobItem>
      )}
      {!!data?.additional_requirements && (
        <JobItem title="Additional Requirements">
          <p
            dangerouslySetInnerHTML={{
              __html: data?.additional_requirements || "",
            }}
          />
        </JobItem>
      )}
      <JobItem title="Job Location">{data?.job_location}</JobItem>
      <JobItem title="Salary">{data?.job_salary || "Negotiable"}</JobItem>
      <JobItem title="Job Type">
        {data?.employment_type ? JType[data?.employment_type] : ""}
      </JobItem>
      {!!data?.gender && (
        <JobItem title="Gender">
          {jobGenderList.find((gd) => gd.value === data?.gender)?.label}
        </JobItem>
      )}
      {!!data?.age_range && (
        <JobItem title="Age Range">{data?.age_range}</JobItem>
      )}
      {!!data?.deadline && (
        <JobItem title="Circular Deadline">
          {dayjs(data?.deadline).format(dateFormat)}
        </JobItem>
      )}
      {!!data?.created_at && (
        <JobItem title="Published Date">{formatDate(data?.created_at)}</JobItem>
      )}
      {!!data?.compensation_benefits && (
        <JobItem title="Compensation & Other Benefits">
          <p
            dangerouslySetInnerHTML={{
              __html: data?.compensation_benefits || "",
            }}
          />
        </JobItem>
      )}
      {!!isShowCompany && (
        <JobItem title="Company Information">
          <div className="text-sm !font-semibold mb-1">
            {data?.company_name || data?.createdByMember?.business?.name}
          </div>
          <ul className="flex flex-col gap-0.5">
            <li>Number of Employee : {data?.company_no_of_employees || 0}</li>
            <li>
              Website :{" "}
              {data?.company_website ? (
                <a
                  href={data?.company_website}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {data?.company_website}
                </a>
              ) : (
                "N/A"
              )}
            </li>
            {/* <li>
            Email :{" "}
            {data?.company_how_to_receive_application
              ? data?.company_how_to_receive_application
              : "N/A"}
          </li> */}
            <li>About Company:</li>
          </ul>

          {!!data?.company_about && (
            <div dangerouslySetInnerHTML={{ __html: data?.company_about }} />
          )}
        </JobItem>
      )}
    </div>
  );
}

type IJobItem = {
  title: string;
  children: ReactNode;
  className?: string;
};
const JobItem = ({ title, className, children }: IJobItem) => {
  return (
    <div className={`mb-4 job-post-admin ${className}`}>
      <h3 className="text-base font-medium text-header">{title}</h3>

      <div>{children}</div>
    </div>
  );
};
